import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import { sync } from 'vuex-router-sync'
import { v4 as generateUuid } from 'uuid'
// eslint-disable-next-line
const unsync = sync(store, router) //Returns an unsync callback fn
import axios from 'axios'
import moment from 'moment-mini'
import swal from 'sweetalert2'
import DateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import { VueMaskDirective } from 'v-mask';


Vue.directive('mask', VueMaskDirective);

Vue.config.productionTip = false

Vue.component('date-range-picker', DateRangePicker)

Vue.prototype.$moment = moment;
Vue.prototype.$http = axios.create({
  baseURL: process.env.VUE_APP_API_URL
});
Vue.prototype.$http.interceptors.request.use(
  (config) => {
    if(store.state.access_token) config.headers['Authorization'] = 'Bearer ' + store.state.access_token
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)
Vue.prototype.$http.interceptors.response.use(
  (response) => {
    if(response.headers && response.headers['x-admin-version']) {
      let avs = response.headers['x-admin-version'].toString();
      let cvs = process.env.VERSION.toString();
      let avs_split = avs.split('.');
      let cvs_split = cvs.split('.');
      if(
        (cvs_split[0] < avs_split[0]) ||
        (cvs_split[0] == avs_split[0] && cvs_split[1] < avs_split[1]) ||
        (cvs_split[0] == avs_split[0] && cvs_split[1] == avs_split[1] && cvs_split[2] < avs_split[2])
      )
      {
        Vue.prototype.$swal.fire({
          title: 'You Need to Refresh',
          html: 'The page you are accessing is outdated<br><br>Version Detected: ' + process.env.VERSION + '<br>Curent Version: ' + avs + '<br><br><i>If you continue to see this message please hold Shift, and click the browser refresh button</i>',
          confirmButtonText: 'Refresh Page',
          showCancelButton: false,
          allowOutsideClick: false,
          allowEscapeKey: false
        }).then(result => {
          if(result.value) {
            //document.getElementById('forcePageReload').submit()
            window.location.reload()
          }
        });
      }
    }
    return response
  },
  (error) => {
    if(error.response.status == 401 && !store.state.route.fullPath.match(/^\/auth(\/.*)?$/)) {
      store.dispatch('logoutUser', true)
    }
    return Promise.reject(error)
  }
)

Vue.prototype.$swal = swal.mixin({
  showConfirmButton: true,
  showCancelButton: true,
  reverseButtons: true,
  scrollbarPadding: false,
  confirmButtonColor: '#40ae75',
  cancelButtonColor: '#697d8a'
})

//Redirect for non auth pages
router.beforeEach((to, from, next) => {
  const noAuthRequired  = to.matched.some((route) => route.meta.noauth)
  const billingPage     = to.matched.some((route) => (route.name == 'billing' || route.name == 'billing-success'))
  const authed          = store.getters.isAuthorized
  const productAccess   = store.getters.canAccessProduct
  
  if(authed && !productAccess && !billingPage) {
    next({path: '/billing'})
  } else
  if(!noAuthRequired && !authed) {
    let redir = {
      path: '/auth'
    }
    if(to.fullPath != '/') redir.query = { redirect: to.fullPath }
    next(redir)
  } else
  if(noAuthRequired && authed) {
    next({path: '/'})
  } else {
    next()
  }
})

Vue.filter('filesize', bytes => {
  let divider = 1000
  let size = bytes / divider
  if(size < 1000) return Math.round(size) + ' KB'
  size = size / divider
  if(size < 1000) return size.toFixed(2) + ' MB'
  size = size / divider
  return size.toFixed(2) + ' GB'
})

Vue.filter('phonenumber', phone => {
  if(typeof phone === 'undefined' || !phone || (phone + '').trim() == '') return ''
  let nospaces = ('' + phone).replace(/ /g, '')
  let extMatch = nospaces.match(/((?:extension|extnsn|exten|xtnd|extn|xtn|ext|eso|ete|et|ee|ex|x)(?:\.)?)/i)
  let extension = null

  if(extMatch) {
    let extSplit  = nospaces.split(extMatch[1])
    phone         = extSplit[0]
    extension     = extSplit[1]
  }

  let cleaned = ('' + phone).replace(/[^0-9+]/g, '')
  let match = cleaned.match(/^(?:\+[0-9]{1,3})?(\d{3})(\d{3})(\d{4})$/)
  let finalVal = null
  if(match) {
    finalVal = '(' + match[1] + ') ' + match[2] + '-' + match[3] + (extension !== null ? ' x ' + extension : '')
  } else {
    finalVal = phone + (extension !== null ? ' x ' + extension : '')
  }

  return finalVal
})

Vue.filter('number', amount => {
  let cleaned = ('' + amount).replace(/[^0-9.-]/g, '')
  if(cleaned == '') return '0.00'
  let numberAmount = Math.round( parseFloat(cleaned) * 100 ) / 100
  return new Intl.NumberFormat('en-US', {minimumFractionDigits: 2}).format(numberAmount.toFixed(2))
})
Vue.filter('numberRounded', amount => {
  let cleaned = ('' + amount).replace(/[^0-9.-]/g, '')
  if(cleaned == '') return '0'
  let numberAmount = Math.round(parseFloat(cleaned))
  return new Intl.NumberFormat('en-US').format(numberAmount).replace(/\D00$/, '')
})
Vue.filter('numberRoundedDash', amount => {
  let number = Vue.options.filters.numberRounded(amount)
  if(number == 0) return '-'
  return number
})
Vue.filter('currency', amount => {
  let cleaned = ('' + amount).replace(/[^0-9.-]/g, '')
  if(cleaned == '') return '0.00'
  let numberAmount = Math.round(parseFloat(cleaned) * 100) / 100
  return new Intl.NumberFormat('en-US', {style: 'currency', currency: 'USD'}).format(numberAmount.toFixed(2))
})
Vue.filter('currencyRounded', amount => {
  let cleaned = ('' + amount).replace(/[^0-9.-]/g, '')
  if(cleaned == '') return '0'
  let numberAmount = Math.round(parseFloat(cleaned))
  return new Intl.NumberFormat('en-US', {style: 'currency', currency: 'USD'}).format(numberAmount).replace(/\D00$/, '')
})
Vue.filter('stripeCard', desc => {
  if(!desc) return ''
  let trimmed = desc.split(' ')
  if(trimmed.length <= 1) return trimmed
  let last4   = trimmed[1]
  let spaced = trimmed[0].replace(/_/,' ')
  let split = spaced.split(' ')
  for(let i = 0; i < split.length; i++) {
    let formatted = split[i].charAt(0).toUpperCase() + split[i].slice(1)
    split[i] = formatted
  }
  return split.join(' ') + ' ' + last4
})


new Vue({
  router,
  store,
  vuetify,
  beforeCreate() {
    store.commit('resetCaches')
    store.dispatch('checkForUpdates', true)
  },
  data() {
    return {
      user_uid_cookie_key: 'wiq_user_uid',
    };
  },
  mounted() {
    let ref = this
    this.setUserUidCookie();
    window.addEventListener('focus', function() { ref.docFocused() })
  },
  computed: {
    cdn() {
      return process.env.VUE_APP_CDN_URL
    },
    currentUser() {
      return store.getters.user;
    },
    version() {
      return process.env.VERSION
    }
  },
  methods: {
    docFocused() {
      store.dispatch('checkForUpdates')
    },
    getNumber(value) {
      if(!value) return 0
      value = (value + '').replace(/[^0-9.]/g,'')
      if(!value.match(/^[0-9]+(?:\.[0-9]+)?$/)) return 0
      return parseFloat(value)
    },
    setUserUidCookie() {
      const userUidCookie = document.cookie.split(';').find(c => c.trim().startsWith(this.user_uid_cookie_key));
      if (!userUidCookie) {
        const oneYearFromNow = new Date();
        oneYearFromNow.setFullYear(oneYearFromNow.getFullYear() + 1);

        document.cookie = `${this.user_uid_cookie_key}=${generateUuid()}; domain=wealthyiq.com; expires=${oneYearFromNow.toUTCString()}; path=/; secure`;
      }
    }
  },
  render: h => h(App)
}).$mount('#app')
